<div class="category-table-wrapper">
  <div class="category-name">
    {{ data.name }}
    @if (data.description) {
    <span class="theme-description">&nbsp;| {{ data.description }}</span>
    }
  </div>

  <ag-grid-angular class="messaging-category-grid" style="width: 100%;" [rowData]="filteredRowData"
    [columnDefs]="colDefs" [modules]="modules" [theme]="theme" [domLayout]="'autoHeight'" [suppressCellFocus]="true"
    [gridOptions]="gridOptions">
  </ag-grid-angular>
  <div class="expand-cell" (click)="toggleExpand()">
    <img class="chevron-arrow" [class.up]="!isExpanded" [src]="'svg/sort-arrow.svg' | assetVersion" alt="icon">
    <span class="expand-text">{{ expandText }}</span>
  </div>
</div>